export default "__VITE_ASSET__xX7loxZe__"